// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2tL9q","inner":"Form_inner__17kIm","range":"Form_range__3cEv0","name":"Form_name__OLVXf","actions":"Form_actions__1o1Sw"};